import { DrawerProps, Modal as MuiModal, PaperProps } from '@mui/material';
import { PropsWithChildren } from 'react';

import { ModalSize, ModalSizeValue } from './Modal.constants';

import { ModalContainer } from './Modal.styled';

export type ModalProps = PropsWithChildren<{
  containerProps?: PaperProps | DrawerProps;
  size?: ModalSize;
  onClose?: () => void;
}>;

export function Modal({
  containerProps = {},
  size = ModalSizeValue.SM,
  children,
  onClose,
}: Readonly<ModalProps>) {
  return (
    <MuiModal open hideBackdrop={false} onClose={onClose}>
      <ModalContainer size={size} {...(containerProps as PaperProps)}>
        {children}
      </ModalContainer>
    </MuiModal>
  );
}
